import { render, staticRenderFns } from "./PendencyApprovedDataAttachment.vue?vue&type=template&id=6140e48d"
import script from "./PendencyApprovedDataAttachment.vue?vue&type=script&lang=js"
export * from "./PendencyApprovedDataAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports